module.exports = __webpack_public_path__ + "img/143-645d10.png";